(function () {
  'use strict';

  /* ---- Mobile drawer ---- */
  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-overlay]');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; } }
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---- Live cart count ---- */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.style.display = c.item_count > 0 ? 'grid' : 'none';
        });
      }).catch(function () {});
  }
  refreshCart();

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += (btn.dataset.qty === 'up' ? 1 : -1);
    input.value = Math.max(parseInt(input.min || 1, 10), val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- PDP gallery ---- */
  var mainImg = document.querySelector('[data-pdp-main]');
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = t.dataset.full || t.querySelector('img').src;
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- Variant swatches (visual only demo) ---- */
  document.querySelectorAll('[data-swatch-group]').forEach(function (g) {
    g.querySelectorAll('.pdp__swatch').forEach(function (s) {
      s.addEventListener('click', function () {
        g.querySelectorAll('.pdp__swatch').forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
      });
    });
  });

  /* ---- Add to cart (AJAX) ---- */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCart(); if (btn) { btn.textContent = '✓ ' + (btn.dataset.added || 'Προστέθηκε'); setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600); } })
        .catch(function () { if (btn) { btn.disabled = false; } });
    });
  });

  /* ---- Tabs (shop by pet) ---- */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
      });
    });
  });

  /* ---- Scroll to top ---- */
  document.querySelectorAll('[data-scroll-top]').forEach(function (b) {
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  });

  /* ---- Smooth scroll to reviews ---- */
  document.querySelectorAll('[data-ugc-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector('#reviews'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  /* ---- Carousel ---- */
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-carousel-track]');
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    if (!track) return;
    function step() { var cell = track.querySelector('.carousel__cell'); return cell ? cell.offsetWidth + 18 : 260; }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
  });

  /* ---- Scroll reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
